export default (options) => {
	if (options.ssr) return
	const queryParams = new URLSearchParams(window.location.search)
	const isWarehouse = queryParams.get('deposito') === 'true'
	if (isWarehouse) localStorage.setItem('isWarehouse', isWarehouse)
}
